import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Redirect, useLocation } from 'react-router-dom';
import { Button, Dimmer, Message } from 'semantic-ui-react';
import { Logout } from '../../actions/auth.actions';
import {
	GetOrganisations,
	LoginToOrganisation,
} from '../../actions/organisation.actions';
import { AppState } from '../../types/app-state';
import { AuthState } from '../../types/auth-state';
import { OrganisationState } from '../../types/organisation-state';
import { OrganisationList } from '../OrganisationList/OrganisationList';
import { SimpleFormWrapper } from '../SimpleFormWrapper/SimpleFormWrapper';
import { Spinner } from '../Spinner/Spinner';
import { Logo } from '../Logo/Logo';
import './HomePage.less';

export const HomePage: React.FC = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const { message, loading, organisations, preselectedOrg } = useSelector<
		AppState,
		Partial<OrganisationState>
	>((state) => state.organisation);
	const { newUser, sysadmin } = useSelector<AppState, Partial<AuthState>>(
		(state) => state.auth
	);

	useEffect(() => {
		const fromURL = sessionStorage.getItem('msp_loggedoutfrom');
		if (fromURL && preselectedOrg) {
			dispatch(LoginToOrganisation(preselectedOrg));
		}
		dispatch(GetOrganisations());
	}, [dispatch, preselectedOrg]);

	useEffect(() => {
		if (!newUser && !sysadmin && preselectedOrg) {
			dispatch(LoginToOrganisation(preselectedOrg));
		} else if (
			!newUser &&
			!sysadmin &&
			organisations &&
			organisations.length === 1
		) {
			dispatch(LoginToOrganisation(organisations![0].tenantId));
		}
	}, [dispatch, newUser, sysadmin, preselectedOrg, organisations]);

	const renderOrganisationList = () => {
		if (organisations && organisations.length > 0) {
			return (
				<div className='wrapper'>
					<p>
						Here is a list of organisations you have access to on My Spending
						Planner
					</p>
					<OrganisationList
						data={organisations}
						onClick={(tenantId) => dispatch(LoginToOrganisation(tenantId))}
					/>
				</div>
			);
		} else {
			return (
				<div className='wrapper'>
					<p>You are not a member of any organisations.</p>
					{!sysadmin && (
						<p>
							Contact the person in charge of your My Spending Planner account
							and request access.
						</p>
					)}
				</div>
			);
		}
	};

	const renderAdminActions = () => {
		return (
			<Button fluid primary as={Link} to={'/admin'}>
				Admin Control Panel
			</Button>
		);
	};

	const changePassword = () => {
		window.location.href = '/changepassword';
	};

	if (newUser) {
		return (
			<Redirect
				to={{
					pathname: '/changepassword',
					state: { from: location },
				}}
			/>
		);
	}

	return (
		<div className='home-page'>
			<Dimmer inverted active={loading}>
				<Spinner />
			</Dimmer>
			<SimpleFormWrapper>
				<Logo />
				{message && (
					<Message negative>
						<p>{message}</p>
					</Message>
				)}
				{renderOrganisationList()}
				{sysadmin && renderAdminActions()}
				<Button fluid primary onClick={changePassword}>
					Change Password
				</Button>
				<Button fluid color='grey' onClick={() => dispatch(Logout())}>
					Logout
				</Button>
			</SimpleFormWrapper>
		</div>
	);
};

export default HomePage;
